import React, { useEffect, useState } from 'react'
import Modal from "@/components/Modal/Modal";
import { FormControl, TextField } from '@mui/material';

interface RejectReferralClaimModalProps {
    rejectModalOpen: boolean;
    rejectModalClose: () => void;
    reason: string;
    onSave: (value: string) => void;
    isRejectLoading: boolean;
}
const RejectReferralBusinessModal: React.FC<RejectReferralClaimModalProps> = ({
    rejectModalOpen,
    rejectModalClose,
    reason,
    onSave,
    isRejectLoading,
}) => {

    const [rejectionReason, setRejectionReason] = useState("");
    const [error, setError] = useState("");

    const handleSave = () => {
        if (!rejectionReason.trim()) {
            setError("Reason is required");
            return;
        }
        setError("");
        onSave(rejectionReason);
    };

    useEffect(() => {

        if (!rejectModalOpen) {
            setRejectionReason("");
            setError("");
        }
    }, [rejectModalOpen]);

    return (
        <>
            <Modal
                modalOpen={rejectModalOpen}
                closeModal={rejectModalClose}
                heading="Reason For Claim"
                onSave={handleSave}
                width="400px"
                isLoading={isRejectLoading}
            >

                <div className="px-6 py-4">

                    <TextField
                        fullWidth
                        variant="standard"
                        label="Reason For Rejection"
                        multiline
                        minRows={2}
                        value={rejectionReason}
                        error={!!error}
                        helperText={error}
                        onChange={(e: any) => {
                            setRejectionReason(e.target.value);
                            if (error) setError("");
                        }}
                        //   rules={{ required: "Category name required" }}
                        required
                    />
                </div>

            </Modal>
        </>
    )
}

export default RejectReferralBusinessModal;
